import { render, staticRenderFns } from "./TestProd.vue?vue&type=template&id=19ade640&scoped=true&"
import script from "./TestProd.vue?vue&type=script&lang=ts&"
export * from "./TestProd.vue?vue&type=script&lang=ts&"
import style0 from "./TestProd.vue?vue&type=style&index=0&id=19ade640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ade640",
  null
  
)

export default component.exports